import { Grid } from '@mui/material';
import { FormFieldType } from 'types/types';
import CustomFormSelect from '../CustomFormSelect/CustomFormSelect';
import CustomFormTextInput from '../CustomFormTextInput/CustomFormTextInput';
import { get, useFormContext } from 'react-hook-form';
import { EFormFieldType } from 'enum/EFormFieldType';
import CustomFormTextArea from '../CustomFormTextArea/CustomFormTextArea';
import CustomText from 'components/common/CustomText/CustomText';
import { currencies } from 'common/constants';
import { toFieldError } from 'common/utils';

interface Props {
  field: FormFieldType;
}

export default function FormField({ field }: Props) {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  switch (field.type) {
    case EFormFieldType.TEXT:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.placeholder}
            register={register}
            endIcon={field.endIcon}
            error={toFieldError(get(errors, field.name))}
          />
        </Grid>
      );

    case EFormFieldType.TEXTAREA:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextArea
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.placeholder}
            register={register}
            error={toFieldError(get(errors, field.name))}
          />
        </Grid>
      );

    case EFormFieldType.DROPDOWN:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormSelect
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.placeholder}
            options={field.options || []}
            endIcon={field.endIcon}
            error={toFieldError(get(errors, field.name))}
          />
        </Grid>
      );

    case EFormFieldType.NUMBER:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.placeholder}
            register={register}
            endIcon={field.endIcon}
            type='number'
            slotProps={{
              htmlInput: {
                onWheel: (e: any) => {
                  e.currentTarget.blur();
                },
              },
            }}
            error={toFieldError(get(errors, field.name))}
          />
        </Grid>
      );

    case EFormFieldType.PRICE:
      return (
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.placeholder}
            register={register}
            type='number'
            slotProps={{
              htmlInput: {
                onWheel: (e: any) => {
                  e.currentTarget.blur();
                },
              },
            }}
            endIcon={<CustomText text={currencies.shekel} />}
            error={toFieldError(get(errors, field.name))}
          />
        </Grid>
      );

    default:
      return null;
  }
}